var render = function render(){var _vm=this,_c=_vm._self._c;return _c('no-ssr',[_c('lazy-component',{staticClass:"map-activities",on:{"show":_vm.loadScripts}},[_c('div',{ref:"container",staticClass:"map-activities__container u-absolute-full mapboxgl-map",class:{ _preloader: _vm.preloader },attrs:{"id":_vm.id}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }